import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, HelpCircle } from 'lucide-react';
const FAQS = [{
  q: '¿Necesito experiencia previa?',
  a: 'No, en absoluto. El MegaPack está diseñado específicamente para guiarte desde cero, paso a paso, sin tecnicismos complejos.'
}, {
  q: '¿Es material digital?',
  a: 'Sí, es 100% digital. Recibís acceso inmediato a todo el contenido para descargarlo o verlo online desde cualquier dispositivo (celular, tablet o PC).'
}, {
  q: '¿Es solo teoría?',
  a: 'No. Aunque tiene una base teórica sólida, el enfoque es totalmente práctico. Incluye ejercicios, meditaciones y guías de aplicación real.'
}, {
  q: '¿Tengo soporte si tengo dudas?',
  a: 'Sí, no estás solo/a en este camino. Tendrás acceso a canales de consulta para resolver cualquier inquietud que surja durante tu aprendizaje.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-gray-50 py-24 md:py-32 px-4" data-id="element-80">
      <div className="container mx-auto max-w-3xl" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-amber-100 rounded-full mb-4 text-amber-600" data-id="element-83">
            <HelpCircle className="w-6 h-6" data-id="element-84" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 leading-tight" data-id="element-85">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-86">
          {FAQS.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`border rounded-2xl bg-white overflow-hidden transition-all duration-300 ${openIndex === idx ? 'border-amber-400 shadow-md ring-1 ring-amber-100' : 'border-gray-200 hover:border-amber-200'}`} data-id="element-87">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left" data-id="element-88">
                <span className={`font-bold text-lg transition-colors ${openIndex === idx ? 'text-amber-900' : 'text-gray-900'}`} data-id="element-89">
                  {faq.q}
                </span>
                <span className={`flex-shrink-0 ml-4 p-1 rounded-full transition-colors ${openIndex === idx ? 'bg-amber-100 text-amber-600' : 'bg-gray-100 text-gray-400'}`} data-id="element-90">
                  {openIndex === idx ? <Minus className="w-5 h-5" data-id="element-91" /> : <Plus className="w-5 h-5" data-id="element-92" />}
                </span>
              </button>
              <AnimatePresence data-id="element-93">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-94">
                    <div className="px-6 pb-6 text-gray-600 text-lg leading-relaxed border-t border-gray-100 pt-4 bg-gray-50/50" data-id="element-95">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}